import { useMemo } from "preact/hooks";
import { getShowNativeMobileAppPrompt } from "services/app";

export const useShowNativeMobileAppPrompt = () => useMemo(() => getShowNativeMobileAppPrompt(), []);
